import { Title, Meta } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as globals from '../settings';

@Injectable()
export class SeoService {
    brand = globals.brand;
  constructor(private titleService: Title, private meta: Meta, private translate: TranslateService) { }

  private helloNigerians(text) {
    if (this.brand === 'winaija') {
      const jinniVariations = ['Troll Tech', 'Troll Tech Lotto'];
      jinniVariations.forEach(function (jinn) {
        text = text.replace(jinn, 'Winaija');
      });
      return text;
    } else {
      return text;
    }
  }
  public setTitle(newTitle: string) {
    newTitle = this.helloNigerians(newTitle);

    const currentUrl = window.location.href;

    this.titleService.setTitle(newTitle);
    this.meta.removeTag('name="language"');
    this.meta.removeTag('http-equiv="content-language"');
    this.meta.addTag({'http-equiv': 'content-language', content: this.translate.currentLang});

    let otherLang = '';
    if (this.translate.currentLang === 'de') {
      this.meta.addTag({ name: 'language', content: 'German' });
      otherLang = 'en';
    } else {
      this.meta.addTag({ name: 'language', content: 'English' });
      otherLang = 'de';
    }

    this.meta.removeTag('rel="alternate"');
    if (currentUrl.indexOf('/' + this.translate.currentLang + '/') !== -1) {
      this.meta.addTag({'rel': 'alternate',
        href: currentUrl.replace('/' + this.translate.currentLang + '/', '/' + otherLang + '/'),
        hreflang: otherLang});
    }
  }

  public setDescription(newDescription: string) {
    newDescription = this.helloNigerians(newDescription);
    this.meta.removeTag('name="description"');
    this.meta.addTag({ name: 'description', content: newDescription });
  }

}
